<template>
  <section class="edaryn" v-if="edaryn.length">
    <div class="careerGuideTopInfo">
      <span class="careerGuideTitle">{{ t('careerGuide.section2Title') }}</span>
      <div class="edarynInfo">
        <img :src="edarynInfoImage" alt="edaryn" />
        <span>
          <span class="edarynInfo_grey">{{ t('careerGuide.sourceLabel') }}</span>
          {{ t('careerGuide.sourceValue') }}
        </span>
      </div>
    </div>

    <div class="edarynBody">
      <div class="edarynTop">
        <span>{{ t('careerGuide.section21Title') }}</span>
      </div>
      <div class="edarynList">
        <div class="edarynItem" v-for="(item, index) in edaryn" :key="`edaryn-${index}`">
          <span class="edarynItem__title">{{ item.organization }}</span>
          <div class="edarynItem__bottom">
            <span class="edarynItem__bottom_title">{{ item.name }}</span>
            <div class="edarynItem__bottom_right">
              <span class="edarynItem__bottom_text">
                <span class="edarynItem__bottom_textGrey">{{ t('careerGuide.groupLabel') }}</span>
                {{ item.group }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  edaryn: {
    type: Array,
    default: () => []
  },
  edarynInfoImage: {
    type: String,
    required: true
  }
});

const { t } = useI18n();
</script>

<style scoped>
.careerGuideTopInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
}

.careerGuideTitle {
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #18191f;
}

.edarynInfo {
  font-size: 16px;
  line-height: 24px;
  color: #262626;
  box-shadow: 0 2px 6px rgba(47, 83, 151, 0.1);
  border-radius: 6px;
  padding: 10px 16px;
  border: 1px solid #ebecee;
  background: #f5f6f7;
  display: flex;
  gap: 8px;
}

.edarynInfo_grey {
  color: #474a57;
}

.edarynBody {
  box-shadow: 0 2px 6px rgba(47, 83, 151, 0.1);
  border: 1px solid #ebecee;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.edarynTop {
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #18191f;
}

.edarynList {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.edarynItem {
  border: 1px solid #ebecee;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.edarynItem__title {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #18191f;
}

.edarynItem__bottom {
  display: flex;
  justify-content: space-between;
}

.edarynItem__bottom_title {
  font-size: 14px;
  line-height: 22px;
  color: #474a57;
  max-width: 320px;
}

.edarynItem__bottom_right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.edarynItem__bottom_text {
  color: #18191f;
  font-size: 14px;
  line-height: 22px;
}

.edarynItem__bottom_textGrey {
  color: #8b8b8d;
}

@media screen and (max-width: 768px) {
  .careerGuideTopInfo {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .careerGuideTitle {
    font-size: 16px;
    line-height: 24px;
  }

  .edarynInfo {
    font-size: 12px;
    line-height: 16px;
    gap: 16px;
    align-items: center;
  }

  .edarynInfo img {
    min-width: 24px;
    max-height: 24px;
  }

  .edarynBody {
    padding: 16px;
    gap: 8px;
  }

  .edarynTop {
    font-size: 16px;
    line-height: 20px;
  }

  .edarynItem__bottom {
    flex-direction: column;
    gap: 4px;
  }
}
</style>

